export default __webpack_public_path__ + "static/media/alex-kondratiev-H9t723yPjYI-unsplash.f99e91f6.jpg";